var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Skeleton',{attrs:{"menu-fix":_vm.menuFix},scopedSlots:_vm._u([{key:"nav",fn:function(){return [_c('Nav',{attrs:{"items":_vm.nav.items,"menus":_vm.menu.items}})]},proxy:true}])},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }